import * as React from 'react';

import {FormLocationsTable} from 'shells/forms/form-locations-table';
import {Modal} from 'shells/modal/modal';

import styles from './view-urls-modal.module.css';

type Props = {
    formUrls: string[];
    onClose: () => void;
};

export function ViewUrlsModal(props: Props) {
    return (
        <Modal
            trapFocus={true}
            isOpen={true}
            onClose={props.onClose}
            maxHeight={400}
            headerText='View form'
            headerSubtext='This form was detected on multiple pages. Click one to view it in a new tab.'
        >
            <div className={styles['form-table-container']}>
                <FormLocationsTable
                    linkHeaderTitle='Form locations'
                    isLoading={false}
                    includeStats={false}
                    data={props.formUrls.map((formUrl) => {
                        return {
                            url: formUrl,
                            lastSubmissionDate: null,
                            submissionsCount: 0,
                            conversionRate: 0,
                        };
                    })}
                />
            </div>
        </Modal>
    );
}
